import { render, staticRenderFns } from "./OvertimeBreakdownDetails.vue?vue&type=template&id=298aa9fe"
import script from "./OvertimeBreakdownDetails.vue?vue&type=script&lang=js"
export * from "./OvertimeBreakdownDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports